import request from '@/utils/request'
import {parseFilters, handleTree} from "@/utils/tools";
// 查询部门管理列表
export function listDepartment(query) {
    return request({
        url: '/org/department/findAll',
        method: 'post',
        data: query
    })
}

// 查询部门管理详细
export function getDepartment(id) {
    return request({
        url: '/org/department/findOne?id=' + id,
        method: 'post'
    })
}

// 新增部门管理
export function addDepartment(data) {
    return request({
        url: '/org/department/add',
        method: 'post',
        data: data
    })
}

// 修改部门管理
export function updateDepartment(data) {
    return request({
        url: '/org/department/edit',
        method: 'post',
        data: data
    })
}

// 更新部门
export function updateDepartments(data) {
    return request({
        url: '/org/department/updateDepartments',
        method: 'post',
        data: data
    })
}
// 删除部门管理
export function delDepartment(id) {
    return request({
        url: '/org/department/remove',
        method: 'post',
        data: id
    })
}

// 导出部门管理
export function exportDepartment(query) {
    return request({
        url: '/org/department/export',
        method: 'post',
        data: query
    })
}

/** 查询部门下拉树结构 */
export function getTreeselectDepartment(companyId, hasTop, callback) {
    let _filter = {};
    if(companyId) {
        if(Array.isArray(companyId)){
            _filter['companyId'] = {
                type: 'select',
                value: companyId,
            }
        }else{
            _filter['companyId'] = {
                type: 'select',
                value: [companyId],
            }
        }
    }
    let where = {};
    const filters = parseFilters(_filter)
    if (filters && filters.length > 0) {
        where.filters = filters
    } else {
        // 如果过滤条件为空，设置空数组
        where.filters = []
    }
    const params = {
        pageNum: 1,
        pageSize: 1000,
        where: where,
        order: ''
    }
    console.log("dep par")
    console.log(params)
    console.log("dep par")
    listDepartment(params).then(response => {
        const list = response.data.records;
        let options = [];
        const data = { id:0,
            name:'顶级部门',
            children: []
        };
        data.children = handleTree(response.data.records, "id", "pid");
        if(hasTop){
            options.push(data);
        }else{
            options = data.children;
        }
        callback(list, options);
    });
}
